<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item v-show="false" label="楼层ID">
                  <el-input  v-model="queryForm.floorId"></el-input>
              </el-form-item>
              <el-form-item label="分类ID">
                  <el-input  v-model="queryForm.categoryId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopFloorCategoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopFloorCategory"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopFloorCategory(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopFloorCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopFloorCategoryList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopFloorCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopFloorCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorId"
        label="楼层ID"
        width="180"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryId"
        label="分类ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopFloorCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopFloorCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopFloorCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopFloorCategoryStates[shopFloorCategoryState]"
      :visible.sync="showDialog"
      width="400px"
      :modal='false'
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopFloorCategory"
          ref="shopFloorCategoryForm"
          :rules="rules"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="楼层ID"
            prop="floorId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloorCategory.floorId"-->
<!--              disabled-->
<!--            ></el-input>-->
              <el-select
                  style="width: 180px"
                  v-model="shopFloorCategory.floorId"
                  placeholder="请选择所属楼层"
                  disabled
                  clearable
                  size="small"
              >
                  <el-option v-for="(item,index) in floorIdList " :label="item.floorName" :value="item.id" :key="index"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="分类ID"
            prop="categoryId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloorCategory.categoryId"-->
<!--              :disabled="shopFloorCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 180px"
                  v-model="shopFloorCategory.categoryId"
                  placeholder="请选择部门名称"
                  :disabled="shopFloorCategoryState == 'check'"
                  clearable
                  multiple
                  size="small"
              >
                  <el-tree default-expand-all :data="departmentList" :props="treeProps">
                      <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                          <el-option :label="node.label" :value="data.id"> </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopFloorCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopFloorCategoryList();
                    this.getShopFloorCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopFloorCategoryList();
                    this.getShopFloorCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //ID
                     floorId: '', //楼层ID
                     categoryId: '', //分类ID
                     createUserId: '', //
                     createTime: '', //
                     updateUserId: '', //
                     updateTime: '', //
                     deleteFlag: '', //
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopFloorCategoryState: 'add',
                shopFloorCategoryStates: {
                    add: '新建shop_floor_category',
                    check: '查看shop_floor_category',
                    edit: '修改shop_floor_category'
                },
                did: '',
                multipleSelection: [],
                shopFloorCategoryList: [],
                shopFloorCategory: {
                    id: '', //ID
                    floorId: '', //楼层ID
                    categoryId: '', //分类ID
                    createUserId: '', //
                    createTime: '', //
                    updateUserId: '', //
                    updateTime: '', //
                    deleteFlag: '', //
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    floorId: [{ required: true, message: '楼层ID不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '分类ID不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                floorIdList: [],
                treeProps: {
                    children: 'children',
                    label: 'categoryName'
                },
                departmentList: [],
            };
        },
        created() {
            // this.getShopFloorCategoryList();
            // this.getFloorIdList()
            this.getdepartmentList()
        },
    methods: {
            updateId(id){
                this.queryForm.floorId = id;
                this.getShopFloorCategoryList();
                this.getFloorIdList()
            },
            getdepartmentList(){
                get('/shop/productcategory/findAllAsTree',{}).then((res)=>{
                    if(res.success){
                        this.departmentList = res.treeData
                    }
                })
            },
            getValuebrandId(val){
                this.shopFloorCategory.categoryId = val
            },
            add1(){
                this.$refs.add1.showSelectDialog();
                console.log(this.$refs.add1)
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopFloorCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopFloorCategoryList = [];
            },
            resetDialog() {
                this.shopFloorCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      floorId: this.queryForm.floorId, //楼层ID
                      categoryId: '', //分类ID
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                };
                this.getShopFloorCategoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopFloorCategory = {
                      id: '', //ID
                      floorId: '', //楼层ID
                      categoryId: '', //分类ID
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                };
            },
            submitForm() {
                if (this.shopFloorCategoryState == 'add') {
                    this.$refs.shopFloorCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            let obj = {...this.shopFloorCategory}
                            obj.categoryId = this.shopFloorCategory.categoryId.join(",")
                            post(`/shop/floorcategory/add`,{ ...obj }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopFloorCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopFloorCategoryState == 'edit') {
                    this.$refs.shopFloorCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopFloorCategory.category
                            delete this.shopFloorCategory.updateTime
                            let obj = {...this.shopFloorCategory}
                            obj.categoryId = this.shopFloorCategory.categoryId.join(",")
                            post(`/shop/floorcategory/edit`,{ ...obj }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopFloorCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopFloorCategory() {
                this.showDialog = true;
                this.shopFloorCategoryState = 'add';
                this.shopFloorCategory.floorId = this.queryForm.floorId
            },
            checkShopFloorCategory(shopFloorCategoryId) {
                console.log(shopFloorCategoryId);
                this.currentShopFloorCategoryId = shopFloorCategoryId;

                this.getShopFloorCategoryById();
                this.showDialog = true;
                this.shopFloorCategoryState = 'check';
            },
            editShopFloorCategory(shopFloorCategoryId) {
                console.log('shopFloorCategory', shopFloorCategoryId);
                if (shopFloorCategoryId) {
                    this.currentShopFloorCategoryId = shopFloorCategoryId;
                    this.getShopFloorCategoryById();
                } else {
                    this.shopFloorCategory = { ...this.shopFloorCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopFloorCategoryState = 'edit';
            },
            deleteShopFloorCategory(shopFloorCategoryId) {
                let ids = '';
                if (shopFloorCategoryId) {
                    ids = shopFloorCategoryId;
                } else {
                    ids = this.multipleSelection.map((shopFloorCategory) => shopFloorCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/floorcategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopFloorCategoryList();
                                this.getShopFloorCategoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopFloorCategoryList() {
                this.resetShopFloorCategoryList();
                this.getShopFloorCategoryList();
            },
            getShopFloorCategoryList(query = {}) {
                this.loading = true;
                get(`/shop/floorcategory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopFloorCategoryList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            // 获取楼层
            getFloorIdList(){
                get(`/shop/floor/findAll`,{}).then((res) => {
                    if (res.success) {
                        this.floorIdList = res.list
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopFloorCategoryById() {
                get(`/shop/floorcategory/get`,{ id: this.currentShopFloorCategoryId }).then((res) =>{
                    if(res.success){
                        let obj = {...res.shopFloorCategory}
                        obj.categoryId = obj.categoryId.split(",")
                      this.shopFloorCategory = { ...this.shopFloorCategory,  ...obj};
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopFloorCategoryList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/floorcategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/floorcategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/floorcategory/importData`,formData);
              this.refreshShopFloorCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopFloorCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopFloorCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>